module.exports = __webpack_public_path__ + "images/frontpage_design@3x.png?732324c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_design@3x.png
// module id = 632
// module chunks = 7